<template>
  <div class="san-row">
    <sanitas-collapsible
      v-if="isMobile"
      class="col-md-12 tab-item--collapsible"
      accordion
      :title-label="titleLabel"
      is-reduced
      :is-open="$parent.activeTabId === id"
      @toggle="onCollapsibleTabToggle"
    >
      <slot />
    </sanitas-collapsible>
    <div
      v-else
      :id="id + '-tab'"
      class="col-md-12 tab-item--tabs"
      :class="{ 'tab-item--active': $parent.activeTabId === id }"
      role="tabpanel"
      tabindex="0"
      :titleLabel="titleLabel"
      :aria-labelledby="id"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import SanitasCollapsible from '@/modules/collapsible/SanitasCollapsible'

export default {
  name: 'SanitasTabItem',
  components: { SanitasCollapsible },
  props: {
    id: {
      type: String,
      required: true,
    },
    titleLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return !this.$mq['md!']
    },
  },
  watch: {
    isMobile(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(() => {
          window.dispatchEvent(new CustomEvent('reInitializeWidgets'))
        })
      }
    },
  },
  methods: {
    onCollapsibleTabToggle() {
      window.setTimeout(() => {
        this.$parent.activeTabId = this.id
      }, 500)
    },
  },
}
</script>
<style scoped lang="postcss">
.tab-item--tabs {
  display: none;

  &.tab-item--active {
    display: block;
  }
}
</style>
